import React, { useEffect, useState } from "react";
import topFlowerImg from "../../assets/images/svg/top_flower.svg";
import bottomFlowerImg from "../../assets/images/svg/bottom_flower.svg";
import whiteTopImg from "../../assets/images/png/white_top_vector.png";
import Button from "../common/button/Button";
import {
  ModalList,
  ashramaFacultyList,
} from "../../utils/AshramaFacultyHelper";
import Modal from "../common/modal/Modal";

const AshramaFaculty = () => {
  const [popupOpen, setPopupOpen] = useState(null);

  function showPopup(index) {
    setPopupOpen(popupOpen === index ? null : index);
  }

  const isModalOpen = popupOpen !== null;
  useEffect(() => {
    if (isModalOpen) {
      document.getElementById("html").classList.add("overflow-hidden");
    } else {
      document.getElementById("html").classList.remove("overflow-hidden");
    }

    // Cleanup on component unmount
    return () => {
      document.getElementById("html").classList.remove("overflow-hidden");
    };
  }, [isModalOpen]);
  return (
    <>
      <div className="bg_orange py-0 px-3 position-relative z_index_1 the_mahamantra_section ">
        {/*<img
          className="position-absolute top_flower_mahamantra start-0"
          src={topFlowerImg}
          alt="top_flower"
        />
        <img
          className="position-absolute bottom_flower_mahamantra bottom_flower_faculty end-0 supreme_right_flower"
          src={bottomFlowerImg}
          alt="bottom_flower"
        />*/}
        {/* <img
          className="position-absolute top-0 end-0 w-100 mt_minus_2"
          src={whiteTopImg}
          alt="white_top_vector"
        /> */}
        <div className="container container_modified pt-lg-5 mt-1 mt-sm-1 position-relative z-3">
          <div className="pt-sm-1 pt-xl-1 mt-xl-1 px-lg-5">
            <h3 className="text-light-yellow text-uppercase common_heading_text">
              MANY SALUTATIONS TO
            </h3>
            <h4 className="font-2xl fw-bold text-white px-md-5 mx-lg-5 text-center mb-0 pt-2">
              MAIYASHREE
            </h4>
            <p className="font-sm fw-medium text-white text-center mb-md-4 mb-lg-5 pt-3 px-lg-5 mx-xl-3 lh_25">
              It is not possible to describe Poojya Maiyashree personality but it is not an exaggeration that she is like Goddess Saraswati in writing and speaking, Goddess Lakshmi in generosity and Goddess Kali in not tolerating injustice, impropriety and atrocity. She is a mother to all. Many salutations to Maiyashree
            </p>
          </div>
          <div className="row">
            {ashramaFacultyList.filter((obj)=>false).map((obj, index) => {
              return (
                <div className={`col-md-6 ${obj.customClass}`} key={index}>
                  <div
                    className="position-relative text-center hov_scale transition_03 cursor_pointer"
                    onClick={() => showPopup(index)}
                  >
                    <div className="position-absolute w-100 d-flex justify-content-center bottom-0 pb-4 pb-lg-5 mb-3 mb-lg-2">
                      <Button title={obj.title} className="faculty_btn" />
                    </div>
                    <img
                      src={obj.image}
                      className="w-100 max_sm_w"
                      alt="retreatFacultycard1"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div
          className="nav_overlay position-fixed top-0 start-0 vh-100 w-100 z_index_4"
          onClick={() => setPopupOpen(null)}
        ></div>
      )}
      {isModalOpen && (
        <Modal
          data={ModalList[popupOpen]}
          showPopup={() => setPopupOpen(null)}
        />
      )}
    </>
  );
};

export default AshramaFaculty;
